import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { accessTokenHelper } from 'helpers/token'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { updateQRCodeInfo } from 'services/apis/user'
import { getWhiteboardCode } from 'services/apis/whiteboard'
import { useAppState } from 'state'
import { setWhiteboarUrl } from 'store/actions/Whiteboard'
import { _roomName } from 'store/selectors/Room'
import { _userType } from 'store/selectors/User'

import BottomOptionsContainer from './components/BottomOptionsContainer'
import ClassParticipantsContainer from './components/ClassParticipantsContainer'
import ClassView from './components/ClassView'
import ErrorState from './components/ErrorState'
import NoTeacher from './components/NoTeacher'
import ReloadState from './components/ReloadState'
import * as Styles from './styles'

const ClassRoomMobile = props => {
    const [isTeacherMinimized, setIsTeacherMinimized] = useState(true)
    const { isQuizMode } = useVideoContext()
    const { error, setError } = useAppState()

    const dispatch = useDispatch()
    const sessionId = localStorage.getItem('sessionId')
    const roomName = useSelector(_roomName)
    const userType = useSelector(_userType)
    const accessToken = accessTokenHelper.get()

    useEffect(() => {
        ;(async function generateQRCode() {
            const response = await getWhiteboardCode(roomName)
            const getRequestId = await updateQRCodeInfo({
                accessToken,
                roomName,
                sessionId,
                whiteboardCode: response.data.whiteboard_code,
                userType,
            })
            dispatch(
                setWhiteboarUrl(
                    `${process.env.REACT_APP_WHITEBOARD_URL}?requestId=${getRequestId.data}`
                )
            )
        })()
    }, [accessToken, roomName, sessionId, userType])

    useEffect(() => {
        setIsTeacherMinimized(!!props.artefact)
        // keep dependencies of the hook empty
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    console.count('ClassRoomMobile Component')

    const [utilsVisible, setUtilsVisible] = useState(false)
    useEffect(() => {
        toggleUtilsVisible()
    }, [])

    const toggleUtilsVisible = e => {
        setUtilsVisible(!utilsVisible)
        setTimeout(() => {
            setUtilsVisible(false)
        }, 4000)
    }

    const onErrorClick = useCallback(() => {
        setError(null)
    }, [])

    const teacherView = useMemo(() => {
        return props.teacher || <NoTeacher />
    }, [props.teacher])

    const view = useMemo(() => {
        if (props.artefact) {
            return props.artefact
        }
        return teacherView
    }, [props.mode, props.artefact, teacherView, props.students])

    const studentsList = useMemo(() => {
        return props.students
    }, [props.students])

    return (
        <Styles.Wrapper isQuizMode={isQuizMode}>
            <ClassParticipantsContainer
                isArtefact={!!props.artefact}
                isTeacherMinimized={isTeacherMinimized}
                students={studentsList}
                teacher={props.teacher}
                setIsTeacherMinimized={setIsTeacherMinimized}
            />
            <ClassView
                view={
                    props.artefact && !isTeacherMinimized ? props.teacher : view
                }
                onClick={toggleUtilsVisible}
            />
            <BottomOptionsContainer utilsVisible={utilsVisible} />
            <ReloadState isOpen={false} />
            <ErrorState
                isOpen={!!error}
                errorDescription={error}
                onClose={onErrorClick}
                onClick={onErrorClick}
            />
        </Styles.Wrapper>
    )
}

export default ClassRoomMobile
